<template>
    <div class="quickpay-cgv" :class="{ 'quickpay-cgv--error': hasError }">
        <CompassCheckbox
            :modelValue="checked"
            :showLabel="false"
            :checked="checked"
            :error="hasError"
            @change="handleChange"
        >
            <p
                class="quickpay-cgv__content typographies-paragraph-medium-regular"
                v-html="condition"
            />
        </CompassCheckbox>
    </div>
</template>

<script>
export default {
    props: {
        condition: {
            type: String,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleChange(value) {
            this.$emit('update:checked', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-cgv {
    width: 100%;
    display: flex;
    padding: var(--spacing-1) var(--spacing-3);
    background: var(--colors-common-background-subtle);
    border-radius: var(--spacing-1);

    &--error {
        background: var(--colors-common-background-alert-subtle);
    }

    &__content {
        margin: 0;
    }
}
</style>
